<template>
  <div>
    <protocol-header v-if="protocol"
                     :protocol="protocol"
                     :task="task"></protocol-header>
    
    <div class="mt-2 mb-4">
      <div class="nav-scroller border-bottom">
        <div class="nav nav-tabs active" ref="tabs">
          <a href="#format"
             class="nav-link active"
             data-toggle="tab">
            Formato de renovación</a>
          <a href="#attachments"
             class="nav-link"
             data-toggle="tab">
            Anexos</a>
        </div>
      </div>
    </div>
    
    <div class="tab-content">
      <div class="tab-pane active show" id="format"
           role="tabpanel"
           aria-labelledby="format-tab-title">
        <template v-if="(!task.course || !task.course.has_expired) && (!task.amendment || !task.amendment.has_expired)">
          <h2 id="format-tab-title" class="d-none">Formato de renovación</h2>
          
          <form onsubmit="return false"
                id="form-format"
                ref="form-format">
            
            <div class="form-group mb-4">
              <label for="comments" class="d-block font-weight-bold">
                Comentarios
              </label>
              <textarea name="comments"
                        id="comments"
                        ref="comments"
                        readonly
                        disabled
                        rows="5"
                        cols="5"
                        class="form-control">{{ task.renewal_dictums ? task.renewal_dictums.comments : '' }}</textarea>
            </div>
            
            <div class="form-group mb-4">
              <div class="custom-file">
                <input data-id="format-file"
                       accept="application/pdf"
                       name="format-file"
                       type="file"
                       id="format-file"
                       ref="format-file"
                       class="custom-file-input"
                       @change="() => this.format = this.$refs['format-file'].files[0]">
                <label for="format-file" class="custom-file-label">Seleccione el formato de renovación</label>
              </div>
            </div>
            
            <div class="form-group mb-4">
              <button type="button" class="btn btn-lg btn-primary"
                      @click="sendFormat"
                      :disabled="saving">Enviar formato
              </button>
            </div>
          </form>
        </template>
        <template v-else>
          <div class="alert alert-warning" v-if="task.course && task.course.has_expired">
            Usted no cuenta con un curso de ética vigente. Para poder realizar la renovación anual, necesita un curso de ética vigente.
          </div>
          <div class="alert alert-warning" v-if="task.amendment && task.amendment.has_expired">
            El protocolo cuenta con una enmienda de prórroga con una fecha de término vencida. Es necesario crear una enmienda de prórroga para proceder para con la renovación anual de ética.
          </div>
        </template>
      </div>
      
      <div class="tab-pane" id="attachments"
           role="tabpanel"
           aria-labelledby="attachments-tab-title">
        <h2 id="attachments-tab-title" class="d-none">Anexos</h2>
        
        <div class="page-section">
          <div class="section-block m-0 p-0">
            <div class="row">
              <div class="col">
                <files-list v-if="protocol"
                            :model="protocol"
                            :files="attachments"
                            :save-files-function="saveAttachments"
                            title="Eliminar anexo de renovación"
                            content="<p>¿Está seguro de eliminar el anexo?</p>"
                            @delete-file="deleteAttachment"></files-list>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
    
    <portal to="protocol-modals">
      <ok-cancel-dialog :title="title"
                        id="expired-modal"
                        :content="content"
                        :show-cancel-button="false"
                        :ok-callback="redirectToAmendments"
                        ref="modal"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import FilesList from './FilesList'
  import ProtocolHeader from './ProtocolHeader'
  import OkCancelDialog from '../ui/OkCancelDialog'
  
  export default {
    name: 'EthicsRenewal',
    components: {
      OkCancelDialog,
      FilesList,
      ProtocolHeader,
    },
    props: {
      protocol: Object,
      task: Object,
    },
    data () {
      return {
        format: null,
        saving: false,
        title: '',
        content: '',
      }
    },
    methods: {
      ...mapActions({
        saveEthicsRenewalAttachments: 'protocols/saveEthicsRenewalAttachments',
        removeEthicsRenewalAttachment: 'protocols/removeEthicsRenewalAttachment',
        saveEthicsRenewalFormat: 'protocols/saveEthicsRenewalFormat',
        getEthicsRenewalAttachments: 'protocols/getEthicsRenewalAttachments',
      }),
      
      async load () {
        await this.getEthicsRenewalAttachments({
          protocol: this.protocol,
        })
      },
      
      /**
       * Save attachments.
       *
       * @param files
       * @returns {Promise<void>}
       */
      async saveAttachments (files) {
        const formData = new FormData()
        
        files.forEach(file => {
          formData.append('files[]', file.file)
        })
        
        formData.append('protocol', this.protocol.id)
        
        const response = await this.saveEthicsRenewalAttachments(formData)
        
        const {
                message,
                error,
                status,
              } = response
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.success(message)
        
        $(`#attachments-modal`).modal('hide')
      },
      /**
       * Delete attachment callback.
       *
       * @param file
       * @param callback
       * @returns {Promise<void>}
       */
      async deleteAttachment (file, callback) {
        const response = await this.removeEthicsRenewalAttachment({
          protocol: this.protocol,
          file,
        })
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)
        }
        
        callback(response)
      },
      async sendFormat () {
        if ($(this.$refs['form-format']).valid()) {
          this.saving = true
          
          const formData = new FormData()
          
          formData.append('file', this.format)
          formData.append('protocol', this.protocol.id)
          formData.append('renewal_id', this.protocol.ethics_renewal.id)
          
          const response = await this.saveEthicsRenewalFormat(formData)
          
          const {
                  message,
                  error,
                  status,
                } = response
          if (status === 'error') {
            AlertManager.error(error)
            
            this.saving = false
            
            return
          }
          
          AlertManager.success(message)
          
          setTimeout(() => location.href = '/', 1000)
        }
      },
  
      redirectToAmendments() {
        if(this.task.amendment && this.task.amendment.has_expired) {
          location.href = '/protocolo/enmiendas/registrar'
        }
        else if (this.task.course && this.task.course.has_expired) {
          location.href = '/'
        }
      },

      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      }
    },
    computed: {
      ...mapGetters(['user']),
      ...mapGetters({
        attachments: 'protocols/renewalAttachments',
      }),
    },
    mounted () {
      const vm = this

      // Check expirations
      if (this.task.course && this.task.course.has_expired) {
        this.title   = 'Vigencia del curso de ética.'
        this.content = 'Usted no cuenta con un curso de ética vigente. Para poder realizar la renovación anual, necesita un curso de ética vigente.'
        
        this.$nextTick(() => $('#expired-modal').modal('show'))
        
        return
      }
      
      // Check amendment
      if (this.task.amendment && this.task.amendment.has_expired) {
        this.title   = 'Prórroga vencida.'
        this.content = 'El protocolo cuenta con una enmienda de prórroga con una fecha de término vencida. Es necesario crear una enmienda de prórroga para proceder para con la renovación anual de ética.'
        
        this.$nextTick(() => $('#expired-modal').modal('show'))
        
        return
      }
      
      this.load()
      
      $(() => {
        $(this.$refs['form-format']).validate({
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            
            if (element.is(':radio')) {
              label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
            }
            else {
              label.insertAfter(element)
            }
          },
          rules: {
            'format-file': {
              required: true,
              extension: 'pdf',
              maxsize: (vm.isAdmin() ? 5 : 2) * 1024 * 1024,
            },
          },
          messages: {
            'format-file': {
              required: 'El formato es requerido',
              extension: 'El formato del archivo debe ser PDF.',
              maxsize: `El tamaño del archivo no debe superar los ${ vm.isAdmin() ? 5 : 2 } MB.`,
            },
          },
          submitHandler (form) {
            return false
          },
        })
      })
    },
  }
</script>
